import { Col, Row, message, Spin, Card } from "antd";
import "./Dasboard.css";
import TotalIcon from "../../assets/Icon1.svg";
import LiveIcon from "../../assets/Icon2.svg";
import InprogressIcon from "../../assets/Icon3.svg";
import ClosedIcon from "../../assets/Icon4.svg";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../header/Header";
import GreetingBanner from "./GreetingBanner";
import { useEffect, useRef, useState } from "react";
import { getRequestCount } from "../../services/ApiService";
import { decryptObject } from "../GlobalFunction";

const OPSDashboard = () => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const name = decryptObject(sessionStorage.getItem("sessioninfo")).username;
  const navigate = useNavigate();
  const RequestCount = async () => {
    setLoading(true);

    try {
      const res = await getRequestCount();
      if (res.responseCode === 200) {
        setStats(res.data);
        setLoading(false);
      } else {
        message.error(res.responseMessage);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching users:", error);
    }
  };


  useEffect(() => {
    RequestCount();
  }, []);

  const handleCardClick = (statusValue) => {
    // Must match OnboardForms.status exactly as stored (get_onboard_list
    // does a case-sensitive `==`, not a case-insensitive lookup) --
    // confirmed real bug, 2026-10-29: the lowercase values used here
    // ("onboarded", "joining", "exit") never matched any real status
    // ("Live", "Onboarding", "Exit"), so every card click-through
    // silently landed on an empty list.
    const url = statusValue
      ? `/employee-list?status=${statusValue}`
      : "/employee-list"; // All employees if no status

    navigate(url);
  };

  return (
    <div className="main-box">
      <Sidebar activeId={1} />
      <main className="main-content">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            flex: 1,
            overflow: "hidden",
          }}
        >
          <Header title="Home" />
          <Spin
            spinning={loading}
            tip="Loading..."
            size="large"
            // style={{ minHeight: "80vh" }}
          >
            <div className="responsiveContainer" style={{ padding: 16 }}>
              <Row gutter={[16, 16]}>
                <Col xs={24} md={24}>
                  <GreetingBanner name={name} />
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={6} sm={6} md={6} lg={6}>
                  <Card
                    title={
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "1.4rem",
                        }}
                      >
                        <img
                          src={LiveIcon}
                          alt="Live Icon"
                          style={{ width: 35, height: 35 }}
                        />
                        Onboarded
                      </span>
                    }
                    bordered
                    hoverable
                    onClick={() => handleCardClick("Live")}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "1.5rem",
                        fontWeight: "500",
                      }}
                    >
                      {stats?.live || 0}
                    </div>
                  </Card>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6}>
                  <Card
                    title={
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "1.4rem",
                        }}
                      >
                        <img
                          src={InprogressIcon}
                          alt="In Progress Icon"
                          style={{ width: 35, height: 35 }}
                        />
                        Joining
                      </span>
                    }
                    bordered
                    hoverable
                    onClick={() => handleCardClick("Onboarding")}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "1.5rem",
                        fontWeight: "500",
                      }}
                    >
                      {stats?.onboarding || 0}
                    </div>
                  </Card>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6}>
                  <Card
                    title={
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "1.4rem",
                        }}
                      >
                        <img
                          src={ClosedIcon}
                          alt="Lost/Closed"
                          style={{ width: 35, height: 35 }}
                        />
                        Exit
                      </span>
                    }
                    bordered
                    hoverable
                    onClick={() => handleCardClick("Exit")}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "1.5rem",
                        fontWeight: "500",
                      }}
                    >
                      {stats?.exit || 0}
                    </div>
                  </Card>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6}>
                  <Card
                    title={
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "1.4rem",
                        }}
                      >
                        <img
                          src={TotalIcon}
                          alt="Total"
                          style={{ width: 35, height: 35 }}
                        />
                        Total
                      </span>
                    }
                    bordered
                    hoverable
                  >
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "1.5rem",
                        fontWeight: "500",
                      }}
                    >
                      {stats?.totalRequest}
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </Spin>
        </div>
      </main>
    </div>
  );
};

export default OPSDashboard;
